import { HeatmapOverlay } from "./heat-map-overlay";
import NoDataToDisplay from "./no-data-to-display";


const CustomHeatmap = ({ data = [], width = 600, height = 400, leftLabels, bottomLabels, loading = false }) => {
	if (data.length === 0 || loading) {
		return <NoDataToDisplay loading={loading} />;
	}

	return (
		data && (
			<HeatmapOverlay
				data={data}
				width={width}
				height={height}
				leftLabels={leftLabels}
				bottomLabels={bottomLabels}
			/>
		)
	)
};

export default CustomHeatmap;
